<template>
  <div class="cfdis-related-return box wrapper-document-comments">
    <h1 class="title is-4 has-text-primary title-document-comments">
      Comentarios
    </h1>

    <AppInputField
      id="voucherComments"
      name="voucherComments"
      placeholder="Comentarios"
      :value="comment"
      :disabled="disabled"
      @input="onChange"
      @change="onChange"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Comments',
  components: {
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      comment: state => state.invoice.voucherComments,
    }),
  },
  methods: {
    ...mapMutations({
      setVoucherValue: 'invoice/setValue',
    }),
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setVoucherValue({ accessor, value });
    },
  },
};
</script>

<style scoped>
</style>
